import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: 'wf-main-content',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule],
  styleUrl: 'main-content.component.css',
  template: `
    <div class="content-container">
      <div class="category-header-and-scope">
        <div class="category-header-container">
          <fa-icon class="print-hide" [icon]="categoryIcon()" size="2x"/>
          <h3>{{ categoryName() }}</h3>
          <ng-content select="wf-page-tour"/>
        </div>
        <ng-content select=".tool-scope"/>
      </div>
      <div class="tool">
        <div class="tool-header">
          <h2>{{ toolName() }}</h2>
        </div>
        <div class="tool-content">
          <ng-content/>
        </div>
      </div>
    </div>
  `,
})
export class MainContentComponent {
  readonly categoryName = input.required<string>();
  readonly categoryIcon = input.required<IconDefinition>();
  readonly toolName = input.required<string>();
}
